/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Admin API
 * Admin panel API — operators manage agencies, seats, roles, oversight.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateTierDto,
  RemoveTierResponseDto,
  TierViewDto,
  TiersControllerFindAllV1200,
  TiersControllerFindAllV1Params,
  UpdateTierDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getTiersControllerCreateV1Url = () => {




  return `/v1/tiers`
}

/**
 * @summary Create a subscription tier
 */
export const tiersControllerCreateV1 = async (createTierDto: CreateTierDto, options?: RequestInit): Promise<TierViewDto> => {

  return apiRequest<TierViewDto>(getTiersControllerCreateV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createTierDto)
  }
);}





export const getTiersControllerCreateV1QueryKey = (createTierDto?: CreateTierDto,) => {
    return [
    'POST', `/v1/tiers`, createTierDto
    ] as const;
    }


export const getTiersControllerCreateV1QueryOptions = <TData = Awaited<ReturnType<typeof tiersControllerCreateV1>>, TError = unknown>(createTierDto: CreateTierDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerCreateV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTiersControllerCreateV1QueryKey(createTierDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tiersControllerCreateV1>>> = ({ signal }) => tiersControllerCreateV1(createTierDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tiersControllerCreateV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TiersControllerCreateV1QueryResult = NonNullable<Awaited<ReturnType<typeof tiersControllerCreateV1>>>
export type TiersControllerCreateV1QueryError = unknown


export function useTiersControllerCreateV1<TData = Awaited<ReturnType<typeof tiersControllerCreateV1>>, TError = unknown>(
 createTierDto: CreateTierDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerCreateV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tiersControllerCreateV1>>,
          TError,
          Awaited<ReturnType<typeof tiersControllerCreateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTiersControllerCreateV1<TData = Awaited<ReturnType<typeof tiersControllerCreateV1>>, TError = unknown>(
 createTierDto: CreateTierDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerCreateV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tiersControllerCreateV1>>,
          TError,
          Awaited<ReturnType<typeof tiersControllerCreateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTiersControllerCreateV1<TData = Awaited<ReturnType<typeof tiersControllerCreateV1>>, TError = unknown>(
 createTierDto: CreateTierDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerCreateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Create a subscription tier
 */

export function useTiersControllerCreateV1<TData = Awaited<ReturnType<typeof tiersControllerCreateV1>>, TError = unknown>(
 createTierDto: CreateTierDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerCreateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTiersControllerCreateV1QueryOptions(createTierDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTiersControllerFindAllV1Url = (params?: TiersControllerFindAllV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/tiers?${stringifiedParams}` : `/v1/tiers`
}

/**
 * @summary List tiers (paginated, searchable, orderable; Enterprise last)
 */
export const tiersControllerFindAllV1 = async (params?: TiersControllerFindAllV1Params, options?: RequestInit): Promise<TiersControllerFindAllV1200> => {

  return apiRequest<TiersControllerFindAllV1200>(getTiersControllerFindAllV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTiersControllerFindAllV1QueryKey = (params?: TiersControllerFindAllV1Params,) => {
    return [
    `/v1/tiers`, ...(params ? [params] : [])
    ] as const;
    }


export const getTiersControllerFindAllV1QueryOptions = <TData = Awaited<ReturnType<typeof tiersControllerFindAllV1>>, TError = unknown>(params?: TiersControllerFindAllV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerFindAllV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTiersControllerFindAllV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tiersControllerFindAllV1>>> = ({ signal }) => tiersControllerFindAllV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tiersControllerFindAllV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TiersControllerFindAllV1QueryResult = NonNullable<Awaited<ReturnType<typeof tiersControllerFindAllV1>>>
export type TiersControllerFindAllV1QueryError = unknown


export function useTiersControllerFindAllV1<TData = Awaited<ReturnType<typeof tiersControllerFindAllV1>>, TError = unknown>(
 params: undefined |  TiersControllerFindAllV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerFindAllV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tiersControllerFindAllV1>>,
          TError,
          Awaited<ReturnType<typeof tiersControllerFindAllV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTiersControllerFindAllV1<TData = Awaited<ReturnType<typeof tiersControllerFindAllV1>>, TError = unknown>(
 params?: TiersControllerFindAllV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerFindAllV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tiersControllerFindAllV1>>,
          TError,
          Awaited<ReturnType<typeof tiersControllerFindAllV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTiersControllerFindAllV1<TData = Awaited<ReturnType<typeof tiersControllerFindAllV1>>, TError = unknown>(
 params?: TiersControllerFindAllV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerFindAllV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List tiers (paginated, searchable, orderable; Enterprise last)
 */

export function useTiersControllerFindAllV1<TData = Awaited<ReturnType<typeof tiersControllerFindAllV1>>, TError = unknown>(
 params?: TiersControllerFindAllV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerFindAllV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTiersControllerFindAllV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTiersControllerFindOneV1Url = (id: string,) => {




  return `/v1/tiers/${id}`
}

/**
 * @summary Get one tier
 */
export const tiersControllerFindOneV1 = async (id: string, options?: RequestInit): Promise<TierViewDto> => {

  return apiRequest<TierViewDto>(getTiersControllerFindOneV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTiersControllerFindOneV1QueryKey = (id: string,) => {
    return [
    `/v1/tiers/${id}`
    ] as const;
    }


export const getTiersControllerFindOneV1QueryOptions = <TData = Awaited<ReturnType<typeof tiersControllerFindOneV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerFindOneV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTiersControllerFindOneV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tiersControllerFindOneV1>>> = ({ signal }) => tiersControllerFindOneV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tiersControllerFindOneV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TiersControllerFindOneV1QueryResult = NonNullable<Awaited<ReturnType<typeof tiersControllerFindOneV1>>>
export type TiersControllerFindOneV1QueryError = unknown


export function useTiersControllerFindOneV1<TData = Awaited<ReturnType<typeof tiersControllerFindOneV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerFindOneV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tiersControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof tiersControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTiersControllerFindOneV1<TData = Awaited<ReturnType<typeof tiersControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerFindOneV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tiersControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof tiersControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTiersControllerFindOneV1<TData = Awaited<ReturnType<typeof tiersControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one tier
 */

export function useTiersControllerFindOneV1<TData = Awaited<ReturnType<typeof tiersControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTiersControllerFindOneV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTiersControllerUpdateV1Url = (id: string,) => {




  return `/v1/tiers/${id}`
}

/**
 * @summary Update a tier (prices, limits, badge, archive…)
 */
export const tiersControllerUpdateV1 = async (id: string,
    updateTierDto: UpdateTierDto, options?: RequestInit): Promise<TierViewDto> => {

  return apiRequest<TierViewDto>(getTiersControllerUpdateV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateTierDto)
  }
);}





export const getTiersControllerUpdateV1QueryKey = (id: string,
    updateTierDto?: UpdateTierDto,) => {
    return [
    'PATCH', `/v1/tiers/${id}`, updateTierDto
    ] as const;
    }


export const getTiersControllerUpdateV1QueryOptions = <TData = Awaited<ReturnType<typeof tiersControllerUpdateV1>>, TError = unknown>(id: string,
    updateTierDto: UpdateTierDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerUpdateV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTiersControllerUpdateV1QueryKey(id,updateTierDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tiersControllerUpdateV1>>> = ({ signal }) => tiersControllerUpdateV1(id,updateTierDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tiersControllerUpdateV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TiersControllerUpdateV1QueryResult = NonNullable<Awaited<ReturnType<typeof tiersControllerUpdateV1>>>
export type TiersControllerUpdateV1QueryError = unknown


export function useTiersControllerUpdateV1<TData = Awaited<ReturnType<typeof tiersControllerUpdateV1>>, TError = unknown>(
 id: string,
    updateTierDto: UpdateTierDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerUpdateV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tiersControllerUpdateV1>>,
          TError,
          Awaited<ReturnType<typeof tiersControllerUpdateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTiersControllerUpdateV1<TData = Awaited<ReturnType<typeof tiersControllerUpdateV1>>, TError = unknown>(
 id: string,
    updateTierDto: UpdateTierDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerUpdateV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tiersControllerUpdateV1>>,
          TError,
          Awaited<ReturnType<typeof tiersControllerUpdateV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTiersControllerUpdateV1<TData = Awaited<ReturnType<typeof tiersControllerUpdateV1>>, TError = unknown>(
 id: string,
    updateTierDto: UpdateTierDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerUpdateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Update a tier (prices, limits, badge, archive…)
 */

export function useTiersControllerUpdateV1<TData = Awaited<ReturnType<typeof tiersControllerUpdateV1>>, TError = unknown>(
 id: string,
    updateTierDto: UpdateTierDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerUpdateV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTiersControllerUpdateV1QueryOptions(id,updateTierDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTiersControllerRemoveV1Url = (id: string,) => {




  return `/v1/tiers/${id}`
}

/**
 * @summary Delete a tier nobody has subscribed to
 */
export const tiersControllerRemoveV1 = async (id: string, options?: RequestInit): Promise<RemoveTierResponseDto> => {

  return apiRequest<RemoveTierResponseDto>(getTiersControllerRemoveV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTiersControllerRemoveV1QueryKey = (id: string,) => {
    return [
    'DELETE', `/v1/tiers/${id}`
    ] as const;
    }


export const getTiersControllerRemoveV1QueryOptions = <TData = Awaited<ReturnType<typeof tiersControllerRemoveV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerRemoveV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTiersControllerRemoveV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tiersControllerRemoveV1>>> = ({ signal }) => tiersControllerRemoveV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tiersControllerRemoveV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TiersControllerRemoveV1QueryResult = NonNullable<Awaited<ReturnType<typeof tiersControllerRemoveV1>>>
export type TiersControllerRemoveV1QueryError = unknown


export function useTiersControllerRemoveV1<TData = Awaited<ReturnType<typeof tiersControllerRemoveV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerRemoveV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tiersControllerRemoveV1>>,
          TError,
          Awaited<ReturnType<typeof tiersControllerRemoveV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTiersControllerRemoveV1<TData = Awaited<ReturnType<typeof tiersControllerRemoveV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerRemoveV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tiersControllerRemoveV1>>,
          TError,
          Awaited<ReturnType<typeof tiersControllerRemoveV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTiersControllerRemoveV1<TData = Awaited<ReturnType<typeof tiersControllerRemoveV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerRemoveV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Delete a tier nobody has subscribed to
 */

export function useTiersControllerRemoveV1<TData = Awaited<ReturnType<typeof tiersControllerRemoveV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tiersControllerRemoveV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTiersControllerRemoveV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






